import { CloudAccountActions, CloudAccountsState } from './cloudAccounts.types';

const initialState = {
  deleteCloudAccountState: { status: 'idle', error: '' } as BaseState,
  postCloudAccountState: { status: 'idle', error: '' } as BaseState,
  updateCloudAccountState: { status: 'idle', error: '' } as BaseState,
  cloudAccounts: { status: 'idle', data: [], error: '' } as CloudAccountsState
};

const cloudAccountReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: CloudAccountActions
): typeof initialState => {
  switch (action.type) {
    case 'GET_CLOUD_ACCOUNTS_REQUEST':
      return {
        ...state,
        cloudAccounts: {
          ...state.cloudAccounts,
          error: '',
          status: 'pending'
        }
      };

    case 'GET_CLOUD_ACCOUNTS_SUCCESS':
      return {
        ...state,
        cloudAccounts: {
          data: action.payload,
          error: '',
          status: 'resolved'
        }
      };

    case 'GET_CLOUD_ACCOUNTS_FAILURE':
      return {
        ...state,
        cloudAccounts: {
          ...state.cloudAccounts,
          error: action.payload,
          status: 'rejected'
        }
      };

    case 'POST_CLOUD_ACCOUNT_REQUEST':
      return {
        ...state,
        postCloudAccountState: {
          error: '',
          status: 'pending'
        }
      };

    case 'POST_CLOUD_ACCOUNT_SUCCESS':
      return {
        ...state,
        cloudAccounts: {
          ...state.cloudAccounts,
          data: [...state.cloudAccounts.data, action.payload]
        },
        postCloudAccountState: {
          error: '',
          status: 'resolved'
        }
      };

    case 'POST_CLOUD_ACCOUNT_FAILURE':
      return {
        ...state,
        postCloudAccountState: {
          error: action.payload,
          status: 'rejected'
        }
      };

    case 'DELETE_CLOUD_ACCOUNT_REQUEST':
      return {
        ...state,
        deleteCloudAccountState: {
          error: '',
          status: 'pending'
        }
      };
    case 'DELETE_CLOUD_ACCOUNT_SUCCESS':
      return {
        ...state,
        deleteCloudAccountState: {
          error: '',
          status: 'resolved'
        }
      };

    case 'DELETE_CLOUD_ACCOUNT_FAILURE':
      return {
        ...state,
        deleteCloudAccountState: {
          error: action.payload,
          status: 'rejected'
        }
      };

    case 'UPDATE_CLOUD_ACCOUNT_REQUEST':
      return {
        ...state,
        updateCloudAccountState: {
          error: '',
          status: 'pending'
        }
      };

    case 'UPDATE_CLOUD_ACCOUNT_SUCCESS':
      return {
        ...state,
        updateCloudAccountState: {
          error: '',
          status: 'resolved'
        }
      };

    case 'UPDATE_CLOUD_ACCOUNT_FAILURE':
      return {
        ...state,
        updateCloudAccountState: {
          error: action.payload,
          status: 'rejected'
        }
      };

    default:
      return state;
  }
};

export default cloudAccountReducer;
